import React from "react";
import {
  Card,
  CardContent,
  Chip,
  Grid,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import {
  formatCurrency,
  formatDate,
  getInvoiceStatusDisplay,
} from "../utils/accountsHelpers";

const InvoiceList = ({ invoices = [], onEdit }) => {
  if (!invoices.length)
    return <Typography color="text.secondary">No invoices found.</Typography>;

  return (
    <Grid container spacing={2}>
      {invoices.map((invoice) => {
        const status = getInvoiceStatusDisplay(invoice.status);
        return (
          <Grid item xs={12} md={6} lg={4} key={invoice.id}>
            <Card>
              <CardContent>
                <Typography variant="h6">{invoice.invoiceNumber}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {invoice.partySnapshot?.name || "No customer"}
                </Typography>
                <Stack direction="row" spacing={1} sx={{ my: 1 }}>
                  <Chip
                    label={status.label}
                    color={status.color}
                    size="small"
                  />
                </Stack>
                <Typography variant="body2">
                  Invoice Date: {formatDate(invoice.invoiceDate)}
                </Typography>
                <Typography variant="body2">
                  Due Date: {formatDate(invoice.dueDate)}
                </Typography>
                <Typography variant="body1" sx={{ mt: 1, fontWeight: 600 }}>
                  {formatCurrency(invoice.totals?.grandTotal || 0)}
                </Typography>
                <Button
                  sx={{ mt: 2 }}
                  size="small"
                  variant="outlined"
                  onClick={() => onEdit?.(invoice)}
                >
                  Edit
                </Button>
              </CardContent>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default InvoiceList;
